import React, { useRef } from "react";
import { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
//import { Chart } from "primereact/chart";
import { CSVLink } from "react-csv";
import { KEY_PERFORMANCE_BY_AGENT as header } from "../../Utils/StaticData/DashboardHeader";
import Chart from "chart.js/auto";
import $ from "jquery";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import SkipNextIcon from "@material-ui/icons/SkipNext";
const PerformanceByAgent = (props) => {
  //applicationStatusData: { statusLabels: [], statusValues: [] },
  const [categoryLabels, setcategoryLabels] = React.useState([[]]);
  const [categoryValues, setcategoryValues] = React.useState([[]]);
  //   pieChartStatusData: this.props.pieKeyPerformanceByAgent,
  //const [pieChartCategoryData,setpieChartCategoryData]=React.useState(props.KeyPerformanceByAgent)
  const [csvData, setcsvData] = React.useState(
    props.keyPerformanceByAgentExport
  );
  //const [excludeLegend,setLegend]=useState([])
  const [showExportbtn, setshowExport] = useState(props.showExport);
  const [PageIndex, setPageIndex] = useState(0);
  const [MaxPageIndex, setMaxPageIndex] = useState(0);
  const setData = (pieData, appData, Label, Value, type) => {
    let labelArray = [];
    let valueArray = [];

    if (type === "Category") {
      //loop to extract labels and values for chart from response(json)
      if (pieData !== undefined) {
        for (let i = 0; i < Object.keys(pieData).length; i++) {
          const label = pieData[i].label;
          const value = pieData[i].value;
          labelArray.push(label);
          valueArray.push(value);
        }

        let divideBY =
          labelArray.length / 20 + (labelArray.length % 20 > 0 ? 1 : 0);
        let j = 0,
          k = 1;
        if (divideBY > 0) {
          let labelsets = [];
          let datasets = [];
          for (let i = 1; i <= Math.floor(divideBY); i++) {
            let arr = "";
            if (i === divideBY) {
              arr = labelArray.slice(20 * j);
            } else {
              arr = labelArray.slice(20 * j, 20 * k);
            }
            labelsets[i - 1] = arr;
            j = j + 1;
            k = k + 1;
          }
          j = 0;
          k = 1;
          for (let i = 1; i <= Math.floor(divideBY); i++) {
            let arr = "";
            if (i === divideBY) {
              arr = valueArray.slice(20 * j);
            } else {
              arr = valueArray.slice(20 * j, 20 * k);
            }
            datasets[i - 1] = arr;
            j = j + 1;
            k = k + 1;
          }
          let max = Math.floor(divideBY);
          setMaxPageIndex(max);
          setcategoryLabels(labelsets);
          setcategoryValues(datasets);
        } else {
          setMaxPageIndex(0);
          setcategoryLabels([[]]);
          setcategoryValues([[]]);
        }
      }
      // setcategoryLabels(labelArray)
      // setcategoryValues(valueArray)
    }
  };
  const PaginationHandlerInitial = (e) => {
    if (MaxPageIndex > 1 && PageIndex > 0) {
      setPageIndex(0);
    }
  };
  const PaginationHandlerEnd = (e) => {
    if (MaxPageIndex > 1) {
      setPageIndex(MaxPageIndex - 1);
    }
  };
  const PaginationHandlerBack = (e) => {
    if (MaxPageIndex > 1 && PageIndex > 0) {
      setPageIndex(PageIndex - 1);
    }
  };
  const PaginationHandlerForward = (e) => {
    if (MaxPageIndex > 1 && PageIndex < MaxPageIndex - 1) {
      setPageIndex(PageIndex + 1);
    }
  };
  useEffect(() => {
    setData(
      props.KeyPerformanceByAgent,
      "applicationCategoryData",
      "categoryLabels",
      "categoryValues",
      "Category"
    );
    setcsvData(props.keyPerformanceByAgentExport);
    setshowExport(props.showExport);
  }, [props]);
  useEffect(() => {
    const categoryOptions = {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false,
          animation: true,
          //position: "top",
          // onClick:labelHandler,
          labels: {
            fontSize: 10,
            // generateLabels:(chart)=>{
            //   //console.log("chart",chart)
            //   let visibility=[];
            //   let hidden=[];
            //   for(let i=0;i<chart.data.labels.length;i++){
            //     if(chart.getDataVisibility(i)=== true){
            //     visibility.push('rgba(102,102,102,1)');
            //       hidden.push(false);
            //     }
            //     else{
            //       hidden.push(true);
            //     }
            //   }
            //   //console.table(visibility)
            //   return chart.data.labels.map(
            //     (label,index)=>({
            //       text:label,
            //       fillStyle:chart.data.datasets[0].backgroundColor[index],
            //       fontSize:25,
            //       fontColor:visibility[index],
            //         datasetIndex:index,
            //           //fontColor:visibility[index],
            //           hidden:hidden[index],
            //           lineDash:hidden[index]===true?[]:[0,0],
            //           borderRadius:2,
            //           strokeStyle:"black",
            //           lineCap:"butt"

            //     })
            //   )}
          },
          align: "center",
        },
        // legendCallback:(chart)=>{
        //   console.log("888888")
        //   let labels=chart.data.labels;
        //   let clr=chart.data.datasets[0].backgroundColor;
        //   return (
        //     <ul>
        //       {
        //         labels && labels.map((label,index)=>
        //           <li>
        //             <div>{label}</div>
        //           </li>
        //         )
        //       }
        //     </ul>
        //   )
        // },
        // layout:{
        //   padding:{
        //     left:0,
        //     right:0,
        //     top:0,
        //     bottom:0
        //   }
        // },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data1) => getTooltip(tooltipItem, data1),
          },
        },
        animation: false,
      },
      scales: {
        y: {
          title: {
            display: true,
            text: "No. Of  Enrollments",
            //  padding:15
          },
        },
        x: {
          ticks: {
            display: false,
            //omitXLabels: true,
          },
          // min:0,
          // max:5
        },
      },
    };
    const categoryData = {
      labels: categoryLabels[PageIndex],
      datasets: [
        {
          data: categoryValues[PageIndex],
          label: "Enrollments",
          backgroundColor: [
            "#51b065",
            "#63b0a3",
            "#9b0f86",
            "#56609c",
            "#599651",
            "#a68465",
            "#996077",
            "#609099",
            "#fcba03",
            "#abebf6",
            "#996987",
            "#609090",
            "#fcba13",
            "#dddddd",
            "#99af87",
            "#609690",
            "#fcbe13",
            "#abeb4d",
          ],
          hoverBackgroundColor: [
            "#b9edc4",
            "#abede2",
            "#5a8f86",
            "#56609c",
            "#529651",
            "#a68465",
            "#996077",
            "#609099",
          ],
        },
      ],
    };
    // const moveChart={
    //   id:"moveChart",
    //   afterDraw(chart,args,choptions){
    //     console.log("chart11",chart)
    //   }
    // }
    //console.log("labels",categoryLabels,"values",categoryValues)
    let status = Chart.getChart("agentChart");
    if (status != undefined) {
      status.destroy();
    }
    const ctx = document.getElementById("agentChart");

    const config = {
      type: "line",
      data: categoryData,
      options: categoryOptions,
      // plugins:[moveChart]
      // plugins:[{
      //   beforeInit:function(chart, args, options) {
      //     // Make sure we're applying the legend to the right chart
      //     if (chart.canvas.id === "agentChart") {
      //       const ul = document.createElement('ul');
      //       chart.data.labels.forEach((label, i) => {
      //         ul.innerHTML += `
      //           <li>
      //             <span style="background-color: ${ chart.data.datasets[0].backgroundColor[i] }">
      //               ${ chart.data.datasets[0].data[i] }
      //             </span>
      //             ${ label }
      //           </li>
      //         `;
      //       });

      //       return document.getElementById("legend").appendChild(ul);
      //     }

      //     return;
      //   }
      // }]
      //optiomychart.destroy()ns:categoryOptions
    };

    new Chart(ctx, config);
  }, [categoryLabels, categoryValues, PageIndex]);

  const getTooltip = (tooltipItem, data1) => {
    let index = tooltipItem.index;
    let label = data1.labels[index];
    let value = data1.datasets[0].data[index];
    if (label === "Cancelled") label = "Application is cancelled by plan";
    if (label === "Denied eligibillity")
      label = "Application has been deemed not eligible by plan";
    if (label === "Duplicate application")
      label =
        "A duplicate application exists and currently being reviewed by plan";
    if (label === "Eligibility review")
      label = "The application eligibility is being reviewed";
    if (label === "Incomplete")
      label =
        "Application has incomplete information that is being reviewed by the plan";
    if (label === "Being Submitted to CMS")
      label =
        "The application is currently being submitted to CMS for approval";
    if (label === "RFI") label = "RFI has been initiated by plan";
    return label + " : " + value + " ";
  };

  // const labelHandler=(e,item,legend)=>{
  //  // console.log("test",e,item,legend)
  //   const index=legend.chart.data.labels.indexOf(item.text)
  //  // console.log("index",index)
  //   legend.chart.toggleDataVisibility(index);
  //   legend.chart.update()
  //   if(excludeLegend.indexOf(item.text)===-1){
  //  // console.log("no")
  //   let arr1=excludeLegend;
  //   arr1.push(item.text)
  //   setLegend(arr1)
  //   }
  //   else{
  //     //console.log("yess")
  //     let x=excludeLegend.indexOf(item.text)
  //     let arr2=excludeLegend.splice(x,1)
  //    // console.log("arr",arr2)
  //     setLegend(arr2)
  //     setcsvData(props.keyPerformanceByAgentExport)
  //   }
  //   //console.log("excluded",excludeLegend)
  //   let exportArr=csvData
  //   let arr=[]
  //   for(let i=0;i<exportArr.length;i++){
  //     let flag=false
  //     for(let j=0;j<excludeLegend.length;j++){
  //       if(exportArr[i]?.agentMail===excludeLegend[j]){
  //         flag=true
  //         break;
  //       }
  //     }
  //     if(flag===false)
  //     arr.push(exportArr[i])
  //   }
  //   setcsvData(arr)
  //   //console.log("export",arr)

  // }
  // useEffect(()=>{
  //   console.log()
  //   let exportArr=csvData
  //   for(let i=0;i<exportArr.length;i++){
  //     for(let j=0;j<excludeLegend.length;j++){
  //       if(exportArr[i].agentMail===excludeLegend[j]){
  //         let arr=exportArr.splice(i,1)
  //         exportArr=arr

  //       }
  //     }
  //   }
  //   setcsvData(exportArr)
  //   console.log("export",exportArr)
  // },[excludeLegend])
  //const { statusLabels, statusValues } = this.state.applicationStatusData;
  //const { categoryLabels, categoryValues } =applicationCategoryData;

  return (
    <>
    {props.isModal ?
    <div className="mt-1">
      {showExportbtn && props.KeyPerformanceByAgent?.length > 0 ? (
        <CSVLink
          data={csvData}
          filename={"KeyPerformanceByAgent.csv"}
          className="btn btn-primary float-right csv-export-btn"
          headers={header}
        >
          Export
        </CSVLink>
      ) : null}
      {/* <div style={{display:"flex",flexDirection:"row"}}> */}
      {/* <div id="legend" ></div> */}
      <div>
        <div class="d-flex flex-row">
          <div
            onClick={PaginationHandlerInitial}
            className={PageIndex === 0 ? "pagination-disable" : ""}
          >
            <SkipPreviousIcon />
          </div>
          <div
            onClick={PaginationHandlerBack}
            className={
              PageIndex === 0
                ? "pagination-disable pagination-padding"
                : "pagination-padding"
            }
          >
            <ArrowLeftIcon />
          </div>
          <div
            onClick={PaginationHandlerForward}
            className={
              MaxPageIndex <= 1 || PageIndex === MaxPageIndex - 1
                ? "pagination-disable"
                : ""
            }
          >
            <ArrowRightIcon />
          </div>
          <div
            onClick={PaginationHandlerEnd}
            className={
              MaxPageIndex <= 1 || PageIndex === MaxPageIndex - 1
                ? "pagination-disable"
                : ""
            }
          >
            <SkipNextIcon />
          </div>
        </div>
        <canvas id="agentChart"></canvas>
      </div>
      {/* </div> */}
    </div>
      :
      <canvas id="agentChart"></canvas>
      
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    //PerformanceByAgent:state.webApp.PerformanceByAgent,
    keyPerformanceByAgentExport: state.export.keyPerformanceByAgentExport,
  };
};
const mapDispatchToProps = {
  //getAgentList,
};
export default connect(mapStateToProps, mapDispatchToProps)(PerformanceByAgent);
